// Communication Skills organized by subcategories
export const COMMUNICATION_SKILLS_CATEGORIES = [
  {
    name: 'Verbal Communication',
    skills: [
      'Public Speaking', 'Presentation Skills', 'Speech Delivery',
      'Voice Modulation', 'Active Listening', 'Articulation',
      'Storytelling', 'Persuasive Speaking', 'Conversation Skills',
      'Group Discussion', 'Interview Skills', 'Negotiation',
      'Conflict Resolution', 'Feedback Delivery', 'Professional Speaking'
    ]
  },
  {
    name: 'Written Communication',
    skills: [
      'Business Writing', 'Technical Writing', 'Report Writing',
      'Email Communication', 'Content Creation', 'Documentation',
      'Proposal Writing', 'Editing Skills', 'Proofreading',
      'Style Guidelines', 'Grammar Proficiency', 'Writing Clarity',
      'Audience Adaptation', 'Format Selection', 'Writing Tools'
    ]
  },
  {
    name: 'Digital Communication',
    skills: [
      'Social Media', 'Online Collaboration', 'Virtual Meetings',
      'Digital Presentations', 'Email Management', 'Chat Platforms',
      'Video Conferencing', 'Digital Content', 'Online Etiquette',
      'Digital Tools', 'Remote Communication', 'Platform Selection',
      'Digital Security', 'File Sharing', 'Digital Organization'
    ]
  },
  {
    name: 'Interpersonal Communication',
    skills: [
      'Active Listening', 'Empathy', 'Body Language',
      'Emotional Intelligence', 'Relationship Building', 'Conflict Resolution',
      'Team Communication', 'Cultural Sensitivity', 'Networking',
      'Feedback Reception', 'Trust Building', 'Professional Relationships',
      'Collaboration Skills', 'Group Dynamics', 'Social Skills'
    ]
  },
  {
    name: 'Business Communication',
    skills: [
      'Professional Etiquette', 'Meeting Management', 'Client Communication',
      'Stakeholder Relations', 'Corporate Messaging', 'Brand Communication',
      'Executive Summaries', 'Business Presentations', 'Report Delivery',
      'Strategic Communication', 'Crisis Communication', 'Change Communication',
      'Leadership Communication', 'Corporate Culture', 'Business Protocol'
    ]
  },
  {
    name: 'Visual Communication',
    skills: [
      'Data Visualization', 'Presentation Design', 'Infographic Creation',
      'Visual Storytelling', 'Graphic Elements', 'Chart Selection',
      'Layout Design', 'Visual Hierarchy', 'Color Theory',
      'Image Selection', 'Visual Tools', 'Design Principles',
      'Visual Clarity', 'Brand Guidelines', 'Visual Impact'
    ]
  },
  {
    name: 'Cross-cultural Communication',
    skills: [
      'Cultural Awareness', 'Language Adaptation', 'Global Etiquette',
      'Cultural Sensitivity', 'International Protocol', 'Translation Management',
      'Cultural Training', 'Global Teams', 'Diversity Awareness',
      'International Business', 'Cultural Bridges', 'Global Mindset',
      'Cultural Intelligence', 'Inclusion Practices', 'Global Relations'
    ]
  },
  {
    name: 'Strategic Communication',
    skills: [
      'Message Development', 'Audience Analysis', 'Channel Selection',
      'Communication Planning', 'Impact Assessment', 'Strategy Implementation',
      'Stakeholder Management', 'Crisis Planning', 'Brand Alignment',
      'Change Management', 'Campaign Development', 'Measurement Methods',
      'ROI Analysis', 'Strategy Adaptation', 'Communication Goals'
    ]
  },
  {
    name: 'Team Communication',
    skills: [
      'Team Collaboration', 'Group Facilitation', 'Project Communication',
      'Team Building', 'Conflict Management', 'Leadership Communication',
      'Performance Feedback', 'Team Coordination', 'Meeting Management',
      'Goal Setting', 'Progress Updates', 'Team Motivation',
      'Problem Solving', 'Decision Making', 'Team Development'
    ]
  },
  {
    name: 'Crisis Communication',
    skills: [
      'Emergency Response', 'Media Relations', 'Stakeholder Management',
      'Message Control', 'Reputation Management', 'Crisis Planning',
      'Response Coordination', 'Public Relations', 'Risk Communication',
      'Issue Management', 'Crisis Leadership', 'Recovery Planning',
      'Communication Strategy', 'Media Training', 'Crisis Prevention'
    ]
  },
  {
    name: 'Technical Communication',
    skills: [
      'Technical Writing', 'Documentation', 'User Guides',
      'Process Documentation', 'System Documentation', 'API Documentation',
      'Technical Training', 'Knowledge Base', 'Technical Presentations',
      'User Instructions', 'Technical Support', 'Technical Translation',
      'Technical Reviews', 'Standards Compliance', 'Technical Tools'
    ]
  },
  {
    name: 'Presentation Skills',
    skills: [
      'Slide Design', 'Delivery Techniques', 'Audience Engagement',
      'Visual Aids', 'Story Structure', 'Time Management',
      'Q&A Handling', 'Stage Presence', 'Voice Projection',
      'Body Language', 'Content Organization', 'Technology Use',
      'Presentation Tools', 'Practice Methods', 'Performance Skills'
    ]
  },
  {
    name: 'Negotiation Skills',
    skills: [
      'Negotiation Strategy', 'Conflict Resolution', 'Deal Making',
      'Interest Alignment', 'Value Creation', 'Agreement Building',
      'Relationship Management', 'Problem Solving', 'Active Listening',
      'Persuasion Skills', 'Contract Terms', 'Win-Win Solutions',
      'Negotiation Ethics', 'Cultural Factors', 'Power Dynamics'
    ]
  },
  {
    name: 'Media Communication',
    skills: [
      'Media Relations', 'Press Releases', 'Media Interviews',
      'Social Media Management', 'Content Strategy', 'Brand Messaging',
      'Public Relations', 'Media Planning', 'Crisis Response',
      'Message Development', 'Media Training', 'Reputation Management',
      'Digital Presence', 'Media Monitoring', 'Influencer Relations'
    ]
  },
  {
    name: 'Communication Leadership',
    skills: [
      'Strategic Direction', 'Team Leadership', 'Change Management',
      'Vision Communication', 'Performance Management', 'Innovation Leadership',
      'Communication Strategy', 'Stakeholder Relations', 'Crisis Leadership',
      'Cultural Leadership', 'Digital Leadership', 'Future Planning',
      'Growth Strategy', 'Success Planning', 'Leadership Development'
    ]
  }
];

// Export flattened list for backward compatibility
export const COMMUNICATION_SKILLS = COMMUNICATION_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
